import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpStatusIconComponent from './adpStatusIcon.component';

let adpStatusIconModule = angular.module('adpStatusIcon', [
  uiRouter
])

.component('adpStatusIcon', adpStatusIconComponent)

.name;

export default adpStatusIconModule;



// WEBPACK FOOTER //
// ./src/app/components/adpStatusIcon/adpStatusIcon.js